
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMotionTrueProposal as ObiMotionTrueProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-motion-true-proposal.js';
 
 
 

 
 export const ObiMotionTrueProposal = createComponent({
   react: React,
   tagName: 'obi-motion-true-proposal',
   elementClass: ObiMotionTrueProposalElement,
   events: {
     
   }
  });
 
 